export const state = {
  placeResults: [],
};
